import * as types from '../../constants/log/levelUpLogConstants';

export const levelUpLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    nftUid,
    callback,
    error
  }
) => ({
  type: types.LEVELUPLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error
});

export const levelUpLogList = (list) => ({
  type: types.LEVELUPLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setLevelUpLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_LEVELUPLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const levelUpLogPageReset = () => ({
  type: types.LEVELUPLOG_PAGE_RESET,
});
